<template>
  <div class="homeEventsSearch">
    <!-- <div class="homeEventsSearch_cat">
      <v-checkbox v-model="areaVal" label="エリア選択" />
    </div> -->
    <div class="homeEventsSearch_cat homeEventsSearch_cat-daterange">
      <v-checkbox v-model="hasDateVal" />
      <DateRangePicker
        :min-date="minDatePicker"
        :dates="datesVal"
        :active="hasDateVal"
        @applySetDates="applySetDates($event)"
      />
    </div>
    <div class="homeEventsSearch_cat">
      <v-btn
        v-for="camera in currentGroupCamList"
        :key="camera.id"
        :color="selectedCams[camera.id] ? 'lightBlue' : ''"
        :outlined="!selectedCams[camera.id]"
        depressed
        class="homeEventsSearch_camera"
        x-small
        @click="toggleCamera(camera.id)"
      >
        {{ camera.name }}
      </v-btn>
    </div>
    <div class="homeEventsSearch_cat">
      <v-btn
        v-for="searchKeyEl in searchKeysData"
        :key="searchKeyEl.key"
        :color="selectedSearchKeys[searchKeyEl.key] ? 'lightBlue' : ''"
        :outlined="!selectedSearchKeys[searchKeyEl.key]"
        depressed
        class="homeEventsSearch_searchKey"
        x-small
        @click="toggleSearchKey(searchKeyEl)"
      >
        {{ searchKeyEl.value }}
      </v-btn>
    </div>
    <v-divider />
    <section class="homeEventsSearch_actions">
      <v-btn
        class="homeEventsSearch_search-btn"
        x-small
        :disabled="!isSearchActive"
        @click="$emit('search')"
      >
        検索</v-btn
      >
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import EventService from '@/services/event.service';
import DateRangePicker from '@/components/inputs/DateRangePicker.vue';
import { subtractDays } from '@/utils/date';
import dayjs from 'dayjs';

export default {
  name: 'HomeEventsSearch',
  components: {
    DateRangePicker,
  },
  props: {
    dates: {
      type: Array,
      default: () => [subtractDays(new Date(), 1), new Date()],
    },
    hasDate: {
      type: Boolean,
      default: false,
    },
    cameraIds: {
      type: Array,
      default: () => [],
    },
    searchKeys: {
      type: Array,
      default: () => [],
    },
    selectedCams: {
      type: Object,
      default: () => [],
    },
    selectedSearchKeys: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    eventService: new EventService(),
    loading: false,
    events: [],
    selectedDateRange: false,
  }),
  computed: {
    ...mapGetters('common', {
      currentGroupCamList: 'currentGroupCamList',
      searchKeysData: 'getSearchKeys',
      maxDays: 'maxRetentionPeriodDays',
      minRetentionDate: 'minRetentionDate',
    }),
    ...mapState({
      cameraList: (state) => state.common.cameraList,
      area: (state) => state.common.area,
      homeSeekStart: (state) => state.home.homeSeekStart,
    }),
    minDatePicker() {
      return dayjs(this.minRetentionDate).toDate();
    },
    areaVal: {
      get() {
        return this.area;
      },
      set(val) {
        this.changeArea(val);
      },
    },
    datesVal: {
      get() {
        // Range should start at 00:00 `minDatePicker` days before current day
        // If dates are selected from calendar, make those as value
        const startDate = this.selectedDateRange
          ? this.dates[0]
          : dayjs(this.minDatePicker).startOf('day').format('YYYYMMDDHHmmss');
        return [startDate, this.dates[1]];
      },
      set(val) {
        this.hasDateVal = true;
        this.$emit('update:dates', val);
      },
    },
    hasDateVal: {
      get() {
        return this.hasDate;
      },
      set(val) {
        this.$emit('update:hasDate', val);
      },
    },
    cameraIdsVal: {
      get() {
        return this.cameraIds;
      },
      set(val) {
        this.$emit('update:cameraIds', val);
      },
    },
    searchKeysVal: {
      get() {
        return this.searchKeys;
      },
      set(val) {
        this.$emit('update:searchKeys', val);
      },
    },
    isSearchActive() {
      return [
        this.hasDate,
        Object.keys(this.selectedCams).some((key) => this.selectedCams[key]),
        Object.keys(this.selectedSearchKeys).some(
          (key) => this.selectedSearchKeys[key]
        ),
        this.area,
      ].some((val) => val);
    },
  },
  watch: {
    homeSeekStart() {
      this.selectedDateRange = false;
    },
  },
  created() {},
  methods: {
    toggleCamera(id) {
      if (!this.selectedCams[id]) {
        this.cameraIdsVal = [...this.cameraIdsVal, id];
        this.$set(this.selectedCams, id, true);
      } else {
        const index = this.cameraIdsVal.indexOf(id);
        if (index > -1) {
          this.cameraIdsVal.splice(index, 1);
          this.cameraIdsVal = [...this.cameraIdsVal];
        }
        this.$set(this.selectedCams, id, false);
      }
    },
    toggleSearchKey(searchKey) {
      const id = searchKey.key;
      if (!this.selectedSearchKeys[id]) {
        this.searchKeysVal = [...this.searchKeysVal, searchKey];
        this.$set(this.selectedSearchKeys, id, true);
      } else {
        const index = this.searchKeysVal.findIndex((item) => item.key === id);
        if (index > -1) {
          this.searchKeysVal.splice(index, 1);
          this.searchKeysVal = [...this.searchKeysVal];
        }
        this.$set(this.selectedSearchKeys, id, false);
      }
    },
    applySetDates(event = []) {
      if (event.length) {
        this.selectedDateRange = true;
        this.datesVal = event;
      }
    },
    ...mapActions('common', ['changeArea']),
  },
};
</script>

<style lang="scss">
.homeEventsSearch {
  &_actions {
    text-align: center;
  }
  &_search-btn {
    &.v-btn {
      width: 122px;
      height: 25px !important;
      border-radius: 5px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2 !important;
      font-size: 10px !important;
      font-weight: bold !important;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff !important;
      margin-bottom: 20px;
      &.v-btn--disabled {
        background-color: #eee !important;
        color: #ccc !important;
      }
    }
  }
  &_cat {
    border-top: 1px solid #eee;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    &-daterange {
      flex-wrap: nowrap;
    }
  }
  .v-input--checkbox {
    margin-top: 0;
    padding-top: 10px;
    .v-messages {
      display: none;
    }
    .v-input__slot {
      margin-bottom: 0;
    }
  }
  .v-btn {
    margin-top: 10px;
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
}
</style>
